import { Fragment, useState, useEffect } from 'react'

// third party components
import { Dialog, Transition } from '@headlessui/react'

// styles
import styles from './index.module.scss'

import ProfileMenuPage from 'components/Menu/ProfileMenuPage'

export interface ProfileMenuModalProps<T> {
  setOpenShareModal: any
  copyWalletAddress: any
  open: boolean
  onClose: () => void
}

const ProfileMenuModal = <T,>({ open, onClose, setOpenShareModal, copyWalletAddress }: ProfileMenuModalProps<T>) => {
  const closeModal = () => {
    onClose()
  }

  const [show, setShow] = useState(false)

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setShow(true)
      }, 100)
    }
  }, [open])

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className={styles.container} onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={styles.bgView} />
        </Transition.Child>
        <div className="fixed inset-0" onClick={() => closeModal()}>
          <div className={`${styles.modalView} ${show ? styles.show : styles.hide}`}>
            <div className="w-full h-full">
              <ProfileMenuPage setOpenShareModal={setOpenShareModal} copyWalletAddress={copyWalletAddress} />
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default ProfileMenuModal
